import type { FormatterType } from "@ext/markdown/core/edit/logic/Formatter/Formatters/typeFormats/getFormatterType";
import type { NodeSerializerSpec } from "@ext/markdown/core/edit/logic/Prosemirror/to_markdown";

const blockPropertyFormatter =
	(formatter: FormatterType): NodeSerializerSpec =>
	async (state, node) => {
		await state.wrapContainer(
			formatter.openTag("block-property", { bind: node.attrs.bind }),
			formatter.closeTag("block-property"),
			node,
			async () => await state.renderContent(node),
			formatter.indentsContainers,
		);
	};

export default blockPropertyFormatter;
